/* eslint-disable react/prop-types */
/* eslint-disable react/require-default-props */
import { useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useOnClickOutside } from '@bwoty-web/ui-kit/hooks';
import './dropdown.scss';

const Dropdown = ({
  links,
  onClose,
  isActive = false,
  mainLinkIndex,
  // onClickOutsideExceptions,
}) => {
  const dropdownRef = useRef(null);
  useOnClickOutside(
    dropdownRef,
    () => onClose(),
    isActive,
    false,
    // onClickOutsideExceptions,
  );

  if (!links) {
    return null;
  }

  return (
    <div className="header-dropdown-container" ref={dropdownRef}>
      <ul
        className={cx('header-dropdown', {
          'header-dropdown--three-col':
            links?.length > 5 && mainLinkIndex === 0,
        })}
      >
        {links?.map((link) => (
          <li className="header-dropdown__item" key={link.name}>
            <a
              href={link.href}
              rel={link.rel}
              className="header-dropdown__link"
            >
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

Dropdown.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      rel: PropTypes.string,
      name: PropTypes.string.isRequired,
    }),
  ),
  onClose: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  mainLinkIndex: PropTypes.number,
};

export default Dropdown;
